import * as angular from 'angular';

import { ComponentDefinition } from '../../models/index';

class LoadingPanelController implements angular.IComponentController {
    readonly extraStyles: string;
    readonly isLoading: boolean;
    readonly loadingMessage: string;

    static $inject = [];

}

export const wtLoadingPanel: ComponentDefinition = {
    componentId: 'wtLoadingPanel',
    controller: LoadingPanelController,
    template: require('./loadingPanel.component.html'),
    controllerAs: 'vm',
    bindings: {
        isLoading: '<',
        message: '<',
        extraStyles: '<?'
    }
};